<template>
  <div class="text-center flex flex-col items-center">
    <HeaderH1>Give feedback</HeaderH1>
    <p class="mt-3 max-w-2xl text-lg text-muted">
      As this web app is very new, all feedback is quite essentiel to determine
      priorities and wanted features. We are very thankful for every feature
      requests and bug report you send, as they help shape this application
      organically, based on actual needs.
    </p>
    <p class="mt-3 text-lg text-muted">
      For other inquiries, use
      <NuxtLink to="/get-in-touch" class="underline">this contact form</NuxtLink
      >.
    </p>
    <UCard variant="subtle" class="mt-9 max-w-lg w-full">
      <div class="mt-9">
        <FormLabel required :value="name">Name</FormLabel>
        <UInput v-model="name" class="w-full" size="xl" />
      </div>
      <div class="mt-3">
        <FormLabel
          :value="email"
          :is-valid="(v) => isValidEmail(v as string)"
          required
          >Email</FormLabel
        >
        <UInput v-model="email" class="w-full" size="xl" />
      </div>
      <div class="mt-3">
        <FormLabel required :value="feedback"
          >how can timeplat.eu improve?</FormLabel
        >
        <UTextarea v-model="feedback" size="xl" :rows="8" class="w-full" />
        <div v-if="error" class="text-error-500 text-left mt-6">
          {{ error }}
        </div>
      </div>
      <template #footer>
        <div class="text-left">
          <UButton
            class="cursor-pointer"
            size="xl"
            :loading="loading"
            :disabled="!readyToSubmit"
            @click="sendFeedback"
            >Send feedback</UButton
          >
        </div>
      </template>
    </UCard>
  </div>
</template>

<script setup lang="ts">
const name = ref("");
const email = ref("");
const feedback = ref("");
const error = ref("");
const toast = useToast();
const loading = ref(false);

const readyToSubmit = computed<boolean>(() => {
  if (name.value.length < 3) return false;
  if (!isValidEmail(email.value)) return false;
  if (feedback.value.length < 4) return false;
  return true;
});

function reset() {
  name.value = "";
  email.value = "";
  feedback.value = "";
  error.value = "";
  loading.value = false;
}

async function sendFeedback() {
  loading.value = true;
  error.value = "";
  await $fetch("/api/feedback", {
    method: "POST",
    body: {
      name: name.value,
      msg: feedback.value,
      email: email.value,
    },
    onResponse: (ctx) => {
      if (ctx.response.status === 204) {
        toast.add({
          color: "success",
          title: "Thank you 🙏",
          description: "We will answer you as soon as possible.",
        });
        reset();
      }
    },
    onResponseError: async (ctx) => {
      const msg = await parseApiError(
        ctx.error || ctx.response._data || ctx.response,
      );
      loading.value = false;
      error.value = msg;
    },
  });
}
</script>
